import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ToggleButton from '../ToggleButton/ToggleButton';
import './ToggleList.less';

const ToggleList = ({
  options,
  currentSelection,
  onToggle,
  onHover,
  tooltipMessage,
  narrow, // * TODO: delete after PDP 2.0 is launched
}) => (
  <div
    className={cx('toggle-list', {
      'toggle-list--narrow': narrow,
    })}
  >
    {options.map(option => {
      return (
        <div
          className={cx('toggle-list__item', {
            'toggle-list__item--narrow': narrow,
          })}
          key={option.value}
        >
          <ToggleButton
            active={currentSelection.value === option.value}
            icon={option.disabled ? option.iconDisabled : option.iconEnabled}
            iconWidth={option.iconWidth}
            label={option.label}
            subLabel={option.subTitle}
            value={option.value}
            type={currentSelection.type}
            disabled={option.disabled}
            onClick={option.disabled ? () => {} : onToggle}
            onHover={option.disabled ? () => {} : onHover}
            tooltipMessage={tooltipMessage}
            narrow={narrow}
          />
        </div>
      );
    })}
  </div>
);

ToggleList.propTypes = {
  currentSelection: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
      subTitle: PropTypes.string,
      iconEnabled: PropTypes.node,
      iconDisabled: PropTypes.node,
    })
  ),
  onToggle: PropTypes.func,
  onHover: PropTypes.func,
  tooltipMessage: PropTypes.string,
  narrow: PropTypes.bool,
};

ToggleList.defaultProps = {
  onToggle: () => {},
  onHover: () => {},
  narrow: false,
};

export default ToggleList;
